module.exports = __webpack_public_path__ + "img/RegCat-retired.bdb5f8b7.svg";